import CardInfo from "components/Cards/CardInfo";
import { PqrForm } from "components/forms/PqrForm";
import React from "react";

export function Pqrfs() {
  const peticiones = [
    {
      type: "Petición",
      info: "Es una solicitud formal para requerir información, copias de documentos, certificados o una actuación específica de la institución.",
    },
    {
      type: "Queja",
      info: "Manifestación de inconformidad relacionada con la conducta, atención o comportamiento de nuestro personal administrativo o docente.",
    },
    {
      type: "Reclamo",
      info: "Expresión de insatisfacción debida a la prestación deficiente de nuestros servicios educativos o problemas con la infraestructura/plataformas.",
    },
    {
      type: "Sugerencia",
      info: "Una propuesta, idea o recomendación que nos presentas para mejorar nuestros procesos, metodologías o servicios.",
    },
    {
      type: "Felicitación",
      info: "Reconocimiento positivo hacia nuestros docentes, personal o servicios por un desempeño sobresaliente.",
    },
  ];
  
  return (
    <main>
      <section className="min-h-[80%] bg-primario flex flex-col justify-center items-center text-center gap-4 px-8 py-[25%] sm:py-[10%]  sm:px-6 lg:px-8">
        <h1 className="capitalize text-3xl sm:text-4xl md:text-5xl lg:text-7xl 2xl:text-8xl font-bold w-full sm:w-5/6 md:w-2/3 text-white leading-tight">
          Sistema de Atención al Usuario{" "}
          <strong className="text-secundario">PQRSF</strong>
        </h1>
        <p className="text-white font-bold text-base sm:text-lg md:text-xl w-full sm:w-5/6 md:w-2/3">
          En Brighton Centro de Inglés, tu experiencia y crecimiento son nuestra
          prioridad. Nos esforzamos por brindarte un servicio de idiomas con los
          más altos estándares de calidad.
        </p>
      </section>
      <section className="p-5 md:p-14 lg:px-20 py-24 flex flex-col items-center justify-center gap-10">
        <p className="text-primario text-base lg:text-xl font-bold text-center">
          Este espacio está diseñado para escucharte. A través de nuestro
          sistema de PQRSF, puedes registrar de manera formal cualquier
          solicitud. Cada caso es analizado por nuestro equipo de calidad para
          darte una respuesta oportuna y aplicar mejoras continuas en nuestra
          institución.
        </p>
        <h2 className="text-3xl md:text-4xl xl:text-5xl font-bold text-secundario">
          Conoce los tipos de solicitudes
        </h2>
        <p className="text-base lg:text-xl w-full text-center hyphens-none">
          Antes de diligenciar el formulario, te invitamos a identificar la
          naturaleza de tu mensaje para darle el trámite correcto
        </p>
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {peticiones.map((item, index) => (
            <CardInfo key={index} title={item.type} description={item.info} />
          ))}
          <div className="outline outline-2 outline-secundario rounded-lg p-5 flex flex-col items-center justify-around text-center text-sm shadow-custom-yellow-1 bg-yellow-100">
            <h3 className="text-secundario font-bold text-xl">
              Tiempos de respuesta
            </h3>
            <p>
              De acuerdo con nuestras{" "}
              <a
                href="https://brightonenglishcenter.edu.co/politica-de-datos"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-800 underline"
              >
                políticas de calidad
              </a>{" "}
              y la normativa legal vigente, todas las solicitudes serán
              evaluadas y respondidas en el plazo descrito en la seccion de{" "}
              <strong>"Procedimientos"</strong>.
            </p>
          </div>
        </div>
      </section>
      <h2 className="text-3xl md:text-4xl xl:text-5xl font-bold text-secundario text-center">
        Formulario de PQRSF
      </h2>
      <PqrForm />
      
    </main>
  );
}
